/**
 * A2A Developer Service
 * Wraps developer operations using A2A client
 */

import { A2AClient } from '../client.js';
import { config } from '../../config/environment.js';

// Get MyClass AI server URL from environment config
const getA2ABackendUrl = () => {
  // Try process.env first (for react-scripts/CRA)
  if (typeof process !== 'undefined' && process.env?.REACT_APP_A2A_BACKEND_URL) {
    return process.env.REACT_APP_A2A_BACKEND_URL;
  }
  if (typeof process !== 'undefined' && process.env?.REACT_APP_MYCLASS_AI_SERVER_URL) {
    return process.env.REACT_APP_MYCLASS_AI_SERVER_URL;
  }
  // Try import.meta.env (for Vite)
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_MYCLASS_AI_SERVER_URL) {
    return import.meta.env.VITE_MYCLASS_AI_SERVER_URL;
  }
  // Use config from environment.js
  if (config?.aiServers?.myclass) {
    return config.aiServers.myclass;
  }
  // Fallback to production URL
  return 'https://a2amyclassai-server.appsokay.net';
};

// Initialize A2A client with correct URL
const a2aClient = new A2AClient(
  getA2ABackendUrl(),
  'myclass-client-developer',
  {
    secretKey: typeof process !== 'undefined' ? process.env.REACT_APP_A2A_SECRET_KEY : undefined,
    enableLogging: typeof process !== 'undefined' ? process.env.NODE_ENV === 'development' : true
  }
);

/**
 * A2A Developer Service
 */
export const a2aDeveloperService = {
  // App Management
  listApps: async (params) => {
    return await a2aClient.executeTask('list_developer_apps', params);
  },
  
  createApp: async (params) => {
    return await a2aClient.executeTask('create_app', params);
  },
  
  updateApp: async (params) => {
    return await a2aClient.executeTask('update_app', params);
  },
  
  deleteApp: async (params) => {
    return await a2aClient.executeTask('delete_app', params);
  },
  
  submitAppForReview: async (params) => {
    return await a2aClient.executeTask('submit_app_for_review', params);
  },
  
  // API Management
  getAPIKeys: async (params) => {
    return await a2aClient.executeTask('get_api_keys', params);
  },
  
  generateAPIKey: async (params) => {
    return await a2aClient.executeTask('generate_api_key', params);
  },
  
  revokeAPIKey: async (params) => {
    return await a2aClient.executeTask('revoke_api_key', params);
  },
  
  testAPIEndpoint: async (params) => {
    return await a2aClient.executeTask('test_api_endpoint', params);
  },
  
  // Analytics
  getAppAnalytics: async (params) => {
    return await a2aClient.executeTask('get_app_analytics', params);
  },
  
  getAPIUsage: async (params) => {
    return await a2aClient.executeTask('get_api_usage', params);
  },
  
  // Revenue
  getRevenueSummary: async (params) => {
    return await a2aClient.executeTask('get_revenue_summary', params);
  },
  
  getPayoutHistory: async (params) => {
    return await a2aClient.executeTask('get_payout_history', params);
  },
  
  requestPayout: async (params) => {
    return await a2aClient.executeTask('request_payout', params);
  },
  
  // Developer Profile
  getDeveloperProfile: async (params) => {
    return await a2aClient.executeTask('get_developer_profile', params);
  }
};

